<nav class="crumbs" aria-label="Você está em">
  <a [routerLink]="['/campaigns']">Automações</a>
  <i class="fa fa-angle-right" aria-hidden="true"></i>
  <span>{{ campaign?.name || title }}</span>
</nav>

<header class="page-head">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-bolt"></i></span>
    <div>
      <h1 class="page-head__title">{{ campaign?.name || title }}</h1>
      <p class="page-head__subtitle" *ngIf="campaign?.lead_list">Automação da lista <strong>{{ campaign.lead_list.name }}</strong></p>
      <p class="page-head__subtitle" *ngIf="!campaignId">Dê um nome, escolha a lista e salve: depois é só montar a sequência de passos.</p>
    </div>
  </div>
  <div class="page-head__actions">
    <a *ngIf="campaignId" [routerLink]="['/campaigns/new']" class="sf-btn sf-btn--ghost">
      <i class="fa fa-plus-circle"></i> Nova automação
    </a>
    <a [routerLink]="['/campaigns']" class="sf-btn sf-btn--secondary" data-testid="btn-back-campaigns">
      <i class="fa fa-arrow-left"></i> {{ sequences ? "Voltar" : "Cancelar" }}
    </a>
    <button
      type="submit"
      form="campaign-form"
      class="sf-btn sf-btn--primary"
      [appLoadingButton]="isSaving"
      [disabled]="loadingCampaign || formCampaign.invalid"
      data-testid="btn-save-campaign"
    >
      <i class="fa fa-save"></i> Salvar automação
    </button>
  </div>
</header>

<div class="notice notice--warning" *ngIf="showAlert" data-testid="campaign-integration-off">
  <i class="fa fa-exclamation-triangle"></i>
  <div class="notice__body"><span><strong>Atenção:</strong> a integração desta lista está desativada.</span></div>
</div>

<app-skeleton *ngIf="loadingCampaign" variant="text" [count]="10"
  label="Carregando a automação" data-testid="campaign-loading"></app-skeleton>

<form id="campaign-form" [formGroup]="formCampaign" (submit)="save()" *ngIf="!loadingCampaign">
  <section class="sf-card" data-testid="campaign-data">
    <h2 class="section-title"><i class="fa fa-cog"></i> Dados da automação</h2>

    <div class="field-grid">
      <div class="field">
        <label for="name">Nome da automação</label>
        <input
          data-testid="input-name-campaign"
          type="text"
          class="form-control"
          id="name"
          formControlName="name"
          placeholder="Ex.: Recuperação de carrinho"
          [class.is-invalid]="formCampaign.get('name').touched && formCampaign.get('name').invalid"
          #nameInput
        />
        <small
          *ngIf="formCampaign.get('name').errors?.required"
          class="field-error"
          data-testid="input-required-name"
        >
          Preencha o nome da automação
        </small>
        <small
          *ngIf="formCampaign.get('name').errors?.minlength"
          class="field-error"
          data-testid="input-required-name-length"
        >
          O nome da automação deve ter pelo menos 5 caracteres
        </small>
      </div>

      <div class="field">
        <label for="list">Lista</label>
        <app-skeleton *ngIf="loadingLists" variant="text" [count]="1"
          label="Carregando as listas" data-testid="lists-loading"></app-skeleton>
        <select
          name="list"
          id="list"
          class="form-select"
          formControlName="lead_list_id"
          data-testid="select-first-list"
          *ngIf="!loadingLists"
        >
          <option *ngFor="let list of lists" [value]="list.id">
            {{
              list.name +
                (!list.integration || list.integration.active
                  ? ""
                  : " *** [integração desativada]")
            }}
          </option>
        </select>
        <small
          *ngIf="formCampaign.get('lead_list_id').errors?.required"
          class="field-error"
          data-testid="select-required-list"
        >
          Selecione uma lista
        </small>
        <small class="field-hint" data-testid="hint-new-leads">
          A automação vale para os leads que entrarem na lista daqui em diante.
        </small>
      </div>
    </div>

    <div class="toggles">
      <div class="toggle">
        <span class="toggle__lbl">Status</span>
        <app-switcher
          look="v2"
          [checked]="active"
          (change)="toggleActive()"
          label="Automação ativa"
          data-testid="switch-campaign-active"
        ></app-switcher>
      </div>

      <div class="toggle">
        <span class="toggle__lbl">Janela de silêncio</span>
        <div class="toggle__row">
          <app-switcher
            look="v2"
            [checked]="sendWindow"
            (checkedChange)="toggleSendWindow()"
            label="Bloquear envios num horário"
            class="send-window-switcher"
            data-testid="switch-send-window"
          ></app-switcher>
          <button
            type="button"
            class="help-btn send-window-help"
            (click)="openSendWindowInfo()"
            ngbTooltip="Como funciona a Janela de Silêncio?"
            aria-label="Como funciona a Janela de Silêncio?"
            data-testid="btn-send-window-help"
          >
            <i class="fa fa-question-circle"></i>
          </button>
        </div>
      </div>

      <div class="toggle" *ngIf="campaign">
        <span class="toggle__lbl">Active Campaign</span>
        <app-switcher
          look="v2"
          (checkedChange)="includeAC()"
          [checked]="ac"
          label="Integrar com o Active Campaign"
          ngbTooltip="Ativar ou desativar Active Campaign na integração"
          data-testid="switch-active-campaign"
        ></app-switcher>
      </div>
    </div>

    <div class="sub-panel" *ngIf="sendWindow" data-testid="send-window-fields">
      <div class="sub-panel__head">
        <i class="fa fa-moon-o"></i>
        <span>Nenhuma mensagem sai entre o início e o fim da janela.</span>
      </div>
      <div class="field-grid field-grid--3">
        <div class="field">
          <label for="send_window_start_hour">Início da janela (hora)</label>
          <input
            id="send_window_start_hour"
            type="number"
            class="form-control"
            formControlName="send_window_start_hour"
            min="0"
            max="23"
          />
          <small
            class="field-error"
            *ngIf="formCampaign.get('send_window_start_hour').touched && formCampaign.get('send_window_start_hour').errors?.required"
          >Obrigatório quando a janela está ativa.</small>
          <small
            class="field-error"
            *ngIf="formCampaign.get('send_window_start_hour').errors?.min || formCampaign.get('send_window_start_hour').errors?.max"
          >A hora deve estar entre 0 e 23.</small>
          <small
            class="field-hint"
            *ngIf="!formCampaign.get('send_window_start_hour').errors"
          >0 a 23</small>
        </div>
        <div class="field">
          <label for="send_window_end_hour">Fim da janela (hora)</label>
          <input
            id="send_window_end_hour"
            type="number"
            class="form-control"
            formControlName="send_window_end_hour"
            min="0"
            max="23"
          />
          <small
            class="field-error"
            *ngIf="formCampaign.get('send_window_end_hour').touched && formCampaign.get('send_window_end_hour').errors?.required"
          >Obrigatório quando a janela está ativa.</small>
          <small
            class="field-error"
            *ngIf="formCampaign.get('send_window_end_hour').errors?.min || formCampaign.get('send_window_end_hour').errors?.max"
          >A hora deve estar entre 0 e 23.</small>
          <small
            class="field-error"
            *ngIf="formCampaign.errors?.sendWindowSameHours && formCampaign.get('send_window_end_hour').touched"
          >A hora de fim deve ser diferente da hora de início.</small>
          <small
            class="field-hint"
            *ngIf="!formCampaign.get('send_window_end_hour').errors && !formCampaign.errors?.sendWindowSameHours"
          >0 a 23</small>
        </div>
        <div class="field">
          <label for="send_window_grace_minutes">Tolerância (min)</label>
          <input
            id="send_window_grace_minutes"
            type="number"
            class="form-control"
            formControlName="send_window_grace_minutes"
            min="0"
            max="120"
          />
          <small
            class="field-error"
            *ngIf="formCampaign.get('send_window_grace_minutes').errors?.min || formCampaign.get('send_window_grace_minutes').errors?.max"
          >A tolerância deve estar entre 0 e 120 minutos.</small>
          <small
            class="field-hint"
            *ngIf="!formCampaign.get('send_window_grace_minutes').errors"
          >Vazio = modo estrito</small>
        </div>
      </div>
    </div>

    <div *ngIf="ac" id="ac-infos" class="sub-panel" data-testid="ac-fields">
      <div class="sub-panel__head">
        <i class="fa fa-send"></i>
        <span>
          Dados de autenticação para Active Campaign.
          Não sabe como fazer?
          <a href="https://help.activecampaign.com/hc/pt-br/articles/207317590-Introdu%C3%A7%C3%A3o-%C3%A0-API#como-obter-seu-url-e-sua-chave-da-api-activecampaign-0-2" target="_blank" rel="noopener">Clique aqui!</a>
        </span>
      </div>
      <div class="field-grid field-grid--2">
        <div class="field">
          <label for="acURL">URL</label>
          <input
            id="acURL"
            type="text"
            class="form-control"
            formControlName="acURL"
            autocomplete="off"
            placeholder="https://suaconta.api-us1.com"
          />
          <small
            class="field-error"
            *ngIf="acURLInvalid || formCampaign.get('acURL').errors?.invalidUrl || formCampaign.get('acURL').errors?.pattern"
          >
            A URL é inválida.
          </small>
        </div>

        <div class="field">
          <label for="acKey">Chave</label>
          <input
            id="acKey"
            type="password"
            class="form-control"
            formControlName="acKey"
            autocomplete="off"
          />
          <small
            class="field-error"
            *ngIf="formCampaign.get('acKey').value && formCampaign.get('acKey').value.length < 30">
            A chave é inválida.
          </small>
        </div>
      </div>
    </div>
  </section>
</form>

<app-sequences
  *ngIf="campaign && !loadingCampaign"
  [campaign]="campaign"
  [leadList]="campaign.lead_list"
  [sequences]="sequences"
></app-sequences>

<section class="sf-card postbacks" *ngIf="campaign && !loadingCampaign" data-testid="campaign-postbacks">
  <h2 class="section-title"><i class="fa fa-history"></i> Histórico de postbacks</h2>
  <p class="section-hint">Os últimos postbacks recebidos na lista desta automação.</p>
  <div *ngIf="listPostbacks?.length; else noPostbacks" class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Contato</th>
          <th>Telefone</th>
          <th>Produto</th>
          <th>Origem</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pb of listPostbacks" data-testid="row-list-postback">
          <td>{{ pb.lead_name }}</td>
          <td>{{ pb.lead_phone }}</td>
          <td>{{ pb.product_name || '—' }}</td>
          <td><span class="meta-chip">{{ pb.postback_origin }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noPostbacks>
    <p class="empty-hint">Nenhum postback recebido nesta lista ainda.</p>
  </ng-template>
</section>

<ng-template #sendWindowInfoModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fa fa-moon-o"></i>
      Como funciona a Janela de Silêncio?
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body" data-testid="send-window-info">
    <p class="section-hint">
      A <strong>janela de silêncio</strong> permite restringir os horários em que as mensagens
      desta automação podem ser disparadas.
    </p>

    <ul>
      <li>
        <strong>Início e fim da janela:</strong> definem o intervalo de horas em que
        os envios ficam <em>bloqueados</em>. Por exemplo, com início <strong>23h</strong> e fim
        <strong>8h</strong>, nenhuma mensagem é enviada entre 23h e 8h.
      </li>
      <li>
        <strong>Mensagens agendadas dentro do bloqueio</strong> são automaticamente
        adiadas para o próximo horário permitido (após o fim da janela).
      </li>
      <li>
        <strong>Tolerância (min):</strong> margem de minutos para envios de mensagens
        para leads que entraram dentro da janela de silêncio. Ex: Com tolerância de 15 minutos, todas as
        sequências configuradas para até 15 min serão enviadas mesmo que estejam dentro da janela de silêncio.
        Deixar em branco significa que não será enviada nenhuma mensagem dentro da janela de silêncio.
      </li>
      <li>Todas as sequências com {{ '{URL_PIX}' }} serão enviadas mesmo que estejam dentro da janela de silêncio.</li>
    </ul>

    <div class="notice notice--warning notice--sm">
      <i class="fa fa-exclamation-triangle"></i>
      <div class="notice__body">
        <span>
          Um detalhe importante é que, caso a sequência esteja configurada para <strong>0 minuto(s)</strong>,
          o sistema entende que a mensagem deve ser enviada imediatamente após a entrada do lead na automação.
          Assim, se um lead entrar na automação durante o período de bloqueio e a primeira mensagem
          estiver configurada para 0 minuto(s), o sistema tentará enviar a mensagem imediatamente
          sendo ignorada a configuração da janela de silêncio. Para evitar isso, certifique-se de
          configurar a primeira mensagem para pelo menos 1 minuto.
        </span>
      </div>
    </div>

    <div class="notice notice--sm">
      <i class="fa fa-info-circle"></i>
      <div class="notice__body">
        <span>
          Use este recurso para evitar disparos em horários inadequados (madrugada,
          horários comerciais restritos, etc.) sem precisar pausar a automação.
        </span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--primary" (click)="modal.close()" data-testid="btn-send-window-ok">
      Entendi
    </button>
  </div>
</ng-template>
